import { WebPage } from "~/components/layout/WebPage";
import { QENDO_LINKS } from "~/constants/environment";

export default function UpcomingEvents() {
    return <WebPage title="Community events" uri={QENDO_LINKS.events} />;
}
